import { Injectable } from '@angular/core'

import { LocalstorageService } from './localstorage.service'
//import { encryptAES, decryptAES } from './crypto-module'
import {
  EncryptionService
} from  './crypto-module';

@Injectable({
  providedIn: 'root',
})
export class ModalStateService {
  constructor(private sessionStorage: LocalstorageService,  private readonly encryptionService:
      EncryptionService) {}


  /**
   * @deprecated
   */
  getUserCreds() {
    return this.getFromLocalStorage('userCreds', true)
  }


  pushUserCreds(authCreds: any) {
    return this.pushToLocalStorage('userCreds', authCreds, true)
  }

  /**
   * @deprecated
   */
  removeUserCreds() {
    return this.removeFromLocalStorageKey('userCreds')
  }

  updateRememberUsername(username: string) {
    return this.pushToLocalStorage('rememberLogin', username)
  }

  getRememberUsername() {
    return this.getFromLocalStorage('rememberLogin')
  }


  removeTokensAndCreds(){
    this.removeFromLocalStorageKey('userCreds')
    this.removeFromLocalStorageKey('accountRefreshToken')
    this.removeFromLocalStorageKey('ninthWaveTokenString')
    this.removeFromLocalStorageKey('accountAccessToken')
    this.removeFromLocalStorageKey('userSessionToken')
    this.removeFromLocalStorageKey('userRefreshToken')
    this.removeFromLocalStorageKey('userRefreshTokenExpiresOn')
    this.removeFromLocalStorageKey('userTokenExpiresOn')
    this.removeFromLocalStorageKey('userTokenLife')
    this.removeFromLocalStorageKey('_expiredTime')

    this.removeFromLocalStorageKey('appAccessToken')
    this.removeFromLocalStorageKey('appRefreshToken')
    // this.removeFromLocalStorageKey('user_email')
    // this.removeFromLocalStorageKey('isLogout')
    // this.removeFromLocalStorageKey('rememberLogin')
  }




  // always store json
  pushToLocalStorage(key, value: any, secure?: boolean) {
    let val = JSON.stringify(value)
    if (secure) {
     // val = encryptAES(val)
     val =this.encryptionService.encryptAES(val)
    }
    this.sessionStorage.setItem(key, val)
  }

  pushToLocalStorageProps(obj: any, secure?: boolean) {
    Object.keys(obj).forEach((key) => {
      let val = JSON.stringify(obj[key])
      if (secure) {
        //val = encryptAES(val)
        val =this.encryptionService.encryptAES(val)

      }
      this.sessionStorage.setItem(key, val)
    })
  }

  // return object always
  getFromLocalStorage(key, secure?: boolean): any {
    const res = this.sessionStorage.getItem(key)
    if (res) {
      if (secure) {
        //return JSON.parse(decryptAES(res))
        return JSON.parse(this.encryptionService.decryptAES(res))
      }
      return JSON.parse(res)
    }
    return null
  }

  removeFromLocalStorage<T>(obj: T) {
    Object.keys(obj).forEach((key) => {
      this.sessionStorage.removeItem(key)
    })
  }

  removeFromLocalStorageKey(key: string) {
    this.sessionStorage.removeItem(key)
  }

  getFromLocalStorageClass<T>(obj: T, secure?: boolean): T {
    const copy: T = {} as any
    Object.assign(copy, obj)

    Object.keys(obj).forEach((key) => {
      const res = this.sessionStorage.getItem(key)
      if (res) {
        if (secure) {
         // copy[key] = JSON.parse(decryptAES(res))
          copy[key] = JSON.parse(this.encryptionService.decryptAES(res))
        } else {
          copy[key] = JSON.parse(res)
        }
      } else {
        copy[key] = null
      }
    })
    return copy
  }

  getFromLocalStorageProps(obj: any, secure?: boolean): any {
    const result = {}
    Object.keys(obj).forEach((key) => {
      const res = this.sessionStorage.getItem(key)
      if (res) {
        if (secure) {
          result[key] = JSON.parse(this.encryptionService.decryptAES(res))
        } else {
          result[key] = JSON.parse(res)
        }
      } else {
        result[key] = null
      }
    })
    return result
  }
  getFromLocalStorageKeys(keys: string[], secure?: boolean): any {
    const result = {}
    keys.forEach((key) => {
      const res = this.sessionStorage.getItem(key)
      if (res) {
        if (secure) {
          result[key] = JSON.parse(this.encryptionService.decryptAES(res))
        } else {
          result[key] = JSON.parse(res)
        }
      } else {
        result[key] = null
      }
    })
    return result
  }
}
